import React from 'react';
import { Formik, Form, Field } from 'formik';
import { Button, Grid, Divider, Message } from 'semantic-ui-react'
import _ from 'lodash';

import FormsInputsText from '../component/forms/inputs/text/forms_inputs_text';
import FormsInputDropdown from '../component/forms/inputs/dropdown';
import FormsInputsDropdownAddition from '../component/forms/inputs/dropdownaddition';
import FormsInputsSingleCheckbox from '../component/forms/inputs/singlecheckbox';
import FormsInputsDoubleCheckbox from '../component/forms/inputs/doublecheckbox';
import FormsInputsRadioGroupDynamic from '../component/forms/inputs/radiodynamic';

const prepareDrowndownOptionsListNameOfOperationOrSurgicalCode = (options) => {
    return _.map(options, (option, index) => {
        if (option.value === 'No Surgery') {
            return { text: `${option.value}`, value: index };
        }
        return { text: `${option.value} (${option.label})`, value: index };
    })
};

const prepareDrowndownOptionsList = (options) => {
    return _.map(options, (option, index) => {
        return { text: option.value, value: index };
    })
};

const getQnsInitialValues = (questions) => {
    let qnsInitialValues = {};
    for (let i = 0; i < questions.length; i++) {
        const question = questions[i];
        const {id, type, inputs, choices} = question;
        if (type === 'multiple_input') {
            inputs.forEach((input, index) => {
                qnsInitialValues[`qns--${id}--${type}--${index}`] = input.value;
            });
        }
        // else if (type === 'multiple_with_input_sub') {
        //     choices.forEach((input, index) => {
        //         qnsInitialValues[`qns--${id}--${type}--${index}`] = input.checked || false;
        //     });
        // }
    }
    return qnsInitialValues;
}

const getQnsFormikForm = (questions) => {
    // console.log('getQnsFormikForm-questions', questions);
    let renderFormOutput = [];
    for (let i = 0; i < questions.length; i++) {
        const question = questions[i];
        const {id, type, inputs, choices, title} = question;
        if (type === 'multiple_input') {
            renderFormOutput.push(
                <Grid.Column key={i} width={16}>
                    <Divider horizontal>
                        {title}
                    </Divider>
                </Grid.Column>
            );
            inputs.forEach((input, index) => {
                const inputKey = `qns--${id}--${type}--${index}`;
                if (input.type === 'dropdown' && input.title.startsWith('Name of Operation')) {
                    // console.log('inputKey', inputKey);
                    renderFormOutput.push(
                        <Grid.Column key={inputKey}>
                            <Field
                                name={inputKey}
                                label={input.title}
                                options={prepareDrowndownOptionsListNameOfOperationOrSurgicalCode(input.choices)}
                                component={FormsInputsDropdownAddition}
                                secondaryLabel=""
                            />
                        </Grid.Column>
                    );
                }
                else if (input.type === 'dropdown') {
                    renderFormOutput.push(
                        <Grid.Column key={inputKey}>
                            <Field
                                name={inputKey}
                                label={input.title}
                                options={prepareDrowndownOptionsList(input.choices)}
                                component={FormsInputDropdown}
                                secondaryLabel=""
                            />
                        </Grid.Column>
                    );
                }
                else if (input.type === 'input_number') {
                    renderFormOutput.push(
                        <Grid.Column key={inputKey}>
                            <Field
                                name={inputKey}
                                label={input.title}
                                component={FormsInputsText}
                                secondaryLabel=""
                            />
                        </Grid.Column>
                    )
                }
            })
        }
        else if (type === 'multiple_with_input_sub') {
            renderFormOutput.push(
                <Grid.Column key={i} width={16}>
                    <Divider horizontal>
                        {title}
                    </Divider>
                </Grid.Column>
            );
            choices.forEach((input, index) => {
                const inputKey = `qns--${id}--${type}--${index}`;
                renderFormOutput.push(
                    <Grid.Column key={inputKey}>
                        <Field
                            name={inputKey}
                            label={input.title}
                            component={FormsInputsDoubleCheckbox}
                        />
                    </Grid.Column>
                );
            });
        }
        else if (type === 'label') {
            renderFormOutput.push(
                <Grid.Column key={i} width={16}>
                    <Message info>
                        {title}
                    </Message>
                </Grid.Column>
            );
        }
    }
    return renderFormOutput;
}

export {
    getQnsInitialValues,
    getQnsFormikForm
};
